module.exports = __webpack_public_path__ + "img/pressurevalves.c3330a24.jpg";